<script>
	import WaterLine from "../components/WaterLine.svelte";
	import Ducks from "../components/Ducks.svelte";
	import FishFilled from "../components/FishFilled.svelte";
	import FishOutlined from "../components/FishOutlined.svelte";

	// visual components

	import { isPortraitScreen, shareSectionHidden } from '../js/model/stores';
	import { onMount } from 'svelte';

	let _inputName;
	let _inputEmail;
	let _inputPhoneHoneypot;
	let _submitButton;
	let portrait;

	// business logic
	onMount(() => {
		_submitButton.classList.remove('submit--allowed');

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});

		var formElement = document.querySelector("form#participate");
		formElement.addEventListener('submit', function(ev) {
			ev.preventDefault();

			var request = new XMLHttpRequest();

			request.onload = () => {
				if (request.status >= 200 && request.status < 300) {
					// parse JSON
					const response = JSON.parse(request.responseText);
					console.log(response);
					shareSectionHidden.set(!response.$oid);
				}
			};

			request.open("POST", "https://api.wirunterstuetzenchemnitz.de/supporter");
			request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
			var object = {};
			new FormData(formElement).forEach(function(value, key){
				object[key] = value;
			});
			var json = JSON.stringify(object);
			request.send(json);
		}, false);
	});

	function checkIfSubmitPossible() {
		if (_inputName.value === '' || _inputEmail.value === '') {
			_submitButton.classList.remove('submit--allowed');
			return;
		}
		_submitButton.classList.add('submit--allowed');
	}
</script>

<style>
	section {
		padding-top: 10vh;
	}

	section.portrait {
		padding-top: 12vh;
	}

	.content {
		background-color: #d6e5f0;
	}

	h2 {
		z-index: 20;
	}

	.text {
		width: 50%;
		padding-bottom: 4vh;
		padding-left: 24%;
		position: relative;
		z-index: 20;
	}

	.portrait .text {
		width: 80%;
		padding: 0 0 15vh 0;
		margin: 0 auto;
	}

	.input input {
		border-radius: 2em;
		text-align: center;
		z-index: 5;
		min-width: 23vw;
		font-size: var(--font-h1-size);
	}

	.portrait .input input {
		width: 80vw;
	}

	.input input[type=text] {
		border: 2px solid var(--color-blue);
		color: var(--color-grey);
		margin: 0 0 1.2em 0;
	}

	.input input[type=text]::placeholder {
		color: var(--color-grey-alpha);
	}

	.input input[type=submit] {
		background-color: var(--color-light-magenta);
		pointer-events: none;
	}

	.input input[type=submit].submit--allowed {
		background-color: var(--color-magenta);
		cursor: pointer;
		pointer-events: all;
	}

	form {
		overflow: hidden;
	}

	.input input[type=tel] {
		position: absolute;
		left: -100vw;
	}

	div.input:nth-child(3) {
		height: 0px;
	}

	.portrait .fish-outlined-1 {
		width: 4em;
		top: 3vh;
	}

	.portrait .fish-filled-2 {
		width: 7em;
		left: 79vw;
		top: 48vh;
	}

	.portrait .fish-outlined-2,
	.portrait .fish-filled-1 {
		display: none;
	}

	.anchor {
		display: block;
		transform: translateY(-5em);
	}
</style>

<section class:portrait>
	<span class="anchor" id="participate"></span>
	<Ducks/>
	<div class="content">
		<WaterLine speed="4s" top="0" position="top"/>
		<h2>Trag dich ein!</h2>
		<div class="text">
		Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum tempor invidunt ut.
		</div>
		<form id="participate">
			<div class="input"><input type="text" name="name" bind:this={_inputName} on:change={checkIfSubmitPossible} on:keyup={checkIfSubmitPossible} required placeholder="Name"/></div>
			<div class="input"><input type="text" name="email" bind:this={_inputEmail} on:change={checkIfSubmitPossible} on:keyup={checkIfSubmitPossible} required placeholder="E-Mail"/></div>
			<div class="input"><input type="tel" name="phone" bind:this={_inputPhoneHoneypot} placeholder="Telefonnummer"/></div>
			<div class="input"><input type="submit" class="cta submit--allowed" bind:this={_submitButton} value="Senden"/></div>
		</form>
		<div class="fish-outlined-1">
			<FishOutlined size="6em" direction="ltr" left="5vw" top="7vh" speedMultiplier="0.2"/>
		</div>
		<div class="fish-outlined-2">
		<FishOutlined size="4em" direction="rtl" left="90vw" top="18vh" speedMultiplier="0.3"/>
		</div>
		<div class="fish-filled-1">
		<FishFilled size="5em" direction="ltr" left="12vw" top="25vh" speedMultiplier="0.3"/>
		</div>
		<div class="fish-filled-2">
		<FishFilled size="6em" direction="rtl" left="88vw" top="32vh" speedMultiplier="0.5"/>
		</div>
		<WaterLine speed="4s" bottom="0" position="bottom"/>
	</div>
</section>
